import { ShowFile } from '../../../../services/show-file';
import { Component, OnInit } from '@angular/core';
import { BaseComponentService } from '../../../../services/base-component.service';
import { ExportTypes } from '../../../../shared/enum/shared.enum';
import { RelatorioLiq } from '../../../../models/pagamento/relatorioliq';


@Component({
  selector: 'gpa-liq-processado',
  templateUrl: './processado-liq.component.html',
  providers: [BaseComponentService]
})

export class ProcessadoLiqComponent extends BaseComponentService implements OnInit {
  _service: any;
  listaProcessado: RelatorioLiq[];
  subscription: any;
  showFile: ShowFile;

  ngOnInit() {
    this.showFile = new ShowFile();
    if (sessionStorage.getItem('IdLiq') != null) {
      const liq = Number(sessionStorage.getItem('IdLiq'));
      this.getLiqsProcessadas(liq);
    } else {
      this.listaProcessado = [];
    }
  }

  gerarPDF(){
    
    let tipoExportado = ExportTypes.PDF;

    if (this.listaProcessado == null) {
      return;
    }
    this.listaProcessado.forEach(item => {
      item.tipoExportacao = tipoExportado;
    });
    
    this.relatorioLote(this.listaProcessado, ExportTypes.ZIP);
    
  }
  relatorioLote(itens: any, tipoExportado: ExportTypes) {
    
    this._service.routePrefix = '/api/Relatorio/BaixarRelatorioLiquidacaoLote';

    if (itens == null) {
      return;
    }
    
    this.aslibLoadingService.start();

    this.subscription = this.gerarRelatorio(itens, tipoExportado, 'gpa').subscribe(res => {
       // Pega o timestamp atual
      const timestamp = Date.now();

      // Converte para objeto Date
      const dateObj = new Date(timestamp);

      // Extrai data e hora separadas
      const data = dateObj.toLocaleDateString('pt-BR').replace('/', '').replace('/', ''); // Ex.: 10/12/2025
      const hora = dateObj.toLocaleTimeString('pt-BR').replace(':', '').replace(':', ''); // Ex.: 15:42:10

      this.showFile.download(res, tipoExportado, 'LIQs_' +data+'_'+ hora+".zip");
    },
      (error: any) => {
        this.exibirErro(error);
      },
      () => {
        this.unSubscribe();
      }
    );

  }

  unSubscribe() {
    this.aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  getLiqsProcessadas(fileId: number) {
    this._service.routePrefix = '/api/LiqRetorno/ObterLiqsRetornados'.concat(`/${fileId}/${true}`);

    this.listaProcessado = [];

    this.aslibLoadingService.start();

    this.subListar = this._service.getAll('gpa').subscribe(data => {
      this.aslibLoadingService.complete();

      this.listaProcessado = data;

      if (this.listaProcessado && this.listaProcessado.length > 0) {
        if(data[0].todasComErro== true) {
          this.listaProcessado = null;
          this.exibirAviso('Todas as LIQs contem erro. Verifique a aba de Não Processados!');
        }
      }
      else {
        this.exibirAviso('Arquivo em processamento.');
      }     
    },
      (error) => {
        this.aslibLoadingService.complete();
        this.exibirErro(error);
      },
      () => {
      }
    );

  }
}



// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq/processado/processado-liq.component.ts